import BottomSheet from "../BottomSheet/BottomSheet";
import { FaTools, FaCheckCircle } from "react-icons/fa";
import styles from "./ServiceLimitBottomSheet.module.css";

const ServiceLimitBottomSheet = ({

    open,

    onClose,

    carTitle = "",

}) => {

    return (

        <BottomSheet

            open={open}

            onClose={onClose}

        >

            <div className={styles.container}>

                <div className={styles.iconWrapper}>

                    <FaTools />

                </div>

                <h3 className={styles.title}>

                    حداکثر تعداد سرویس ثبت شده

                </h3>

                {

                    carTitle && (

                        <p className={styles.carTitle}>

                            خودرو:

                            <strong>

                                {" "}

                                {carTitle}

                            </strong>

                        </p>

                    )

                }

                <p className={styles.description}>

                    برای هر خودرو حداکثر

                    <strong>

                        {" "}۳۰ سرویس{" "}

                    </strong>

                    قابل ثبت است.

                </p>

                <div className={styles.note}>

                    <div>

                        • در صورت نیاز یکی از سرویس‌های قدیمی را حذف کنید.

                    </div>

                    <div>

                        • یا برای ادامه ثبت سرویس، یک خودروی جدید ایجاد نمایید.

                    </div>

                </div>

                <button

                    type="button"

                    className={styles.button}

                    onClick={onClose}

                >

                    <FaCheckCircle />

                    <span>

                        متوجه شدم

                    </span>

                </button>

            </div>

        </BottomSheet>

    );

};

export default ServiceLimitBottomSheet;